export default __webpack_public_path__ + "static/color-application-light-cd7a5850a38430fcfe5d01f20acfc13ed5f074a391c97f8e62f2956c12c810d9.png";